import { render, staticRenderFns } from "./InsightQuestion.vue?vue&type=template&id=2395809a&scoped=true&"
import script from "./InsightQuestion.vue?vue&type=script&lang=js&"
export * from "./InsightQuestion.vue?vue&type=script&lang=js&"
import style0 from "./InsightQuestion.vue?vue&type=style&index=0&id=2395809a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395809a",
  null
  
)

export default component.exports